import { render, staticRenderFns } from "./TireAdd.vue?vue&type=template&id=2969dce9&scoped=true"
import script from "./TireAdd.vue?vue&type=script&lang=js"
export * from "./TireAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2969dce9",
  null
  
)

export default component.exports